export default function AppSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-lg p-6 md:p-10">
            <div className="flex-shrink-0">
              <div className="w-24 h-24 md:w-28 md:h-28 flex items-center justify-center rounded-2xl bg-primary-500">
                <i className="ri-smartphone-line text-4xl md:text-5xl text-background-50"></i>
              </div>
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">APP下载</h2>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
                51吃瓜网入口移动端体验持续优化中。无论您使用手机还是平板，通过浏览器访问即可获得流畅的吃瓜浏览体验。51吃瓜app下载相关信息将在本站公告区第一时间更新，敬请关注。您也可以将本站添加到手机主屏幕，实现一键快速访问51吃瓜最新地址。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#app"
                  onClick={(e) => handleNavClick(e, '#app')}
                  className="w-full sm:w-auto px-6 py-3 rounded-md bg-foreground-900 text-background-50 font-medium text-sm hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap text-center"
                >
                  <i className="ri-apple-line mr-2"></i>iOS 即将上线
                </a>
                <a
                  href="#app"
                  onClick={(e) => handleNavClick(e, '#app')}
                  className="w-full sm:w-auto px-6 py-3 rounded-md bg-foreground-900 text-background-50 font-medium text-sm hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap text-center"
                >
                  <i className="ri-android-line mr-2"></i>Android 即将上线
                </a>
                <a
                  href="#contact"
                  onClick={(e) => handleNavClick(e, '#contact')}
                  className="w-full sm:w-auto px-6 py-3 rounded-md border border-background-300 text-foreground-600 font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap text-center"
                >
                  预约通知
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}